import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const EditorFadeOutIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="19.4999" cy="15.5" r="1" transform="rotate(180 19.4999 15.5)" stroke="#B8BDC1" />
      <circle cx="5.5" cy="4.5" r="1" transform="rotate(180 5.5 4.5)" stroke="#B8BDC1" />
      <path d="M18.4991 15.5006C11 15.5014 15.0002 4.50168 6.49982 4.50133" stroke={fillColor || '#B8BDC1'} />
    </svg>
  );
};

export { EditorFadeOutIcon };
